// @ts-strict-ignore
import React from 'react'
import { connect } from 'react-redux'
import { brand } from '@r/app-selectors'
import Card from '../../../atoms/card'
import Button from '../../../atoms/button'
import Field, { Label } from '../../../atoms/field'
import Input from '../../../atoms/input'
import RichTextBlock from '@uswitch/ev-components/lib/components/modules/rich-text-block'
import { moneyRichTextBlockStyles, uswitchRichTextBlockStyles } from '../single-column-rich-text'

const Calculator = ({ brand, content, jsonBody, sys, name, rawName, variant }) => {
  return (
    <div className='Calculator' data-controller='calculator' data-calculator-url={jsonBody.url}>
      {content && (
        <RichTextBlock
          style={brand === 'money' ? moneyRichTextBlockStyles : uswitchRichTextBlockStyles}
          content={content}
        />
      )}
      <Card variant='plum'>
        <form className='inner-card'>
          {jsonBody.fields.map((field, i) => (
            <Field key={i}>
              <Label htmlFor={field.name}>{field.label}</Label>
              <Input
                name={field.name}
                type={field.type ?? 'input'}
                prefix={field.prefix}
                suffix={field.suffix}
                value={field.value}
                format={field.format}
              />
            </Field>
          ))}
          <div
            /* eslint-disable camelcase */
            data-click-tracking={JSON.stringify({
              component_category: 'platinum-component',
              component_id: sys?.id,
              component_name: 'credit-card-calculator',
              contentful_name: rawName,
              contentful_variant: variant,
              additionalProps: { text: 'Calculate' },
            })}
            className='calculator-field-wrapper'
          >
            <Button dataAction={'click->calculator#calculate'}>{jsonBody.buttonText}</Button>
          </div>
        </form>
      </Card>
    </div>
  )
}

export default connect((state, props) => {
  return {
    brand: brand(state),
    ...props,
  }
})(Calculator)
